import Entity from './entity'
export default class moisture_threshold extends Entity<number>{
}